import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import TaskDetail from '../pages/TaskDetail';

export function TaskDrawer({ selectedTaskId, isOpen, drawerRef, onClose, onModalOpen, onDataChanged }) {
  return createPortal(
    <>
      {/* Overlay */}
      <div
        data-testid="task-drawer-overlay"
        className="bg-black"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9998,
          opacity: isOpen ? 0.3 : 0,
          transition: 'opacity 300ms ease-in-out',
          pointerEvents: isOpen ? 'auto' : 'none',
          visibility: isOpen ? 'visible' : 'hidden'
        }}
        onClick={onClose}
      />

      {/* Drawer Panel */}
      <div
        ref={drawerRef}
        data-testid="task-drawer-panel"
        className="shadow-2xl overflow-y-auto w-full sm:w-[85%] lg:w-[80%]"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          background: 'var(--bg)',
          color: 'var(--text)',
          borderLeft: '1px solid var(--border)',
          transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          pointerEvents: isOpen ? 'auto' : 'none'
        }}
      >
        {/* Top Buttons */}
        <div className="absolute top-4 right-4 flex items-center gap-2" style={{ zIndex: 10000 }}>
          <button
            data-testid="task-drawer-close-btn"
            onClick={onClose}
            className="p-2 rounded-full shadow-lg transition-colors"
            style={{ background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)' }}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* TaskDetail Component */}
        {selectedTaskId && (
          <TaskDetail
            taskId={selectedTaskId}
            isDrawer={true}
            onModalOpen={onModalOpen}
            onClose={onClose}
            onDataChanged={onDataChanged}
          />
        )}
      </div>
    </>,
    document.body
  );
}
